<p-fieldset legend="Nota de Empenho / Documento Similar">
  <lib-licitacao-audesp-empenho [ajuste]="ajuste" [entidade]="arquivo" [campo]="'Empenho'">
  </lib-licitacao-audesp-empenho>
</p-fieldset>